import React, { useEffect, useState } from "react";
import cn from "classnames";
import useArrayState from "@clave/use-array-state";
import useBooleanState from "@clave/use-boolean-state";
import userApiClient from "../../login-register/UsersApiClient";
import { Checkbox } from "../../components/Checkbox";
import Button from "../../components/Button";
import TextBox from "../../components/TextBox";
import styles from "./MySavedSearches.module.scss";
function Item({ item, onSave, onDelete, strings }) {
    var _a, _b;
    const [sendNotifications, setSendNotifications] = useBooleanState((_a = item === null || item === void 0 ? void 0 : item.sendNotifications) !== null && _a !== void 0 ? _a : false);
    const [editing, setEditing] = useBooleanState(false);
    const [name, setName] = useState((_b = item === null || item === void 0 ? void 0 : item.name) !== null && _b !== void 0 ? _b : "");
    const [confirmDelete, setConfirmDelete] = useBooleanState(false);
    function toggleEdit() {
        if (!item)
            return;
        setSendNotifications(item.sendNotifications);
        setName(item.name);
        setEditing.toggle();
    }
    async function save() {
        if (!item || !onSave)
            return;
        await onSave({
            searchQueryId: item.searchQueryId,
            name,
            sendNotifications,
        });
        toggleEdit();
    }
    async function deleteItem() {
        if (!item || !onDelete)
            return;
        await onDelete(item);
    }
    return (React.createElement("div", { className: cn(styles.item, !item && styles.itemHeader) },
        !item && React.createElement(React.Fragment, null,
            React.createElement("span", null, strings.nameTableHeader),
            React.createElement("span", { className: styles.center }, strings.sendNotificationsTableHeader),
            React.createElement("span", { className: styles.last })),
        !editing && item && React.createElement(React.Fragment, null,
            React.createElement("a", { href: item.searchUrl, target: "_blank" }, item.name),
            React.createElement(Checkbox, { className: styles.center, checked: item.sendNotifications, disabled: true }),
            !confirmDelete && React.createElement("div", { className: cn(styles.itemButtons, styles.last) },
                React.createElement(Button, { label: strings.deleteBtnLabel, onClick: () => setConfirmDelete.toggle() }),
                React.createElement(Button, { label: strings.editBtnLabel, onClick: toggleEdit })),
            confirmDelete && React.createElement("div", { className: cn(styles.itemButtons, styles.last) },
                React.createElement(Button, { label: strings.cancelBtnLabel, onClick: () => setConfirmDelete.toggle() }),
                React.createElement(Button, { label: strings.deleteBtnLabel, kind: "primary", onClick: deleteItem }))),
        editing && item && React.createElement(React.Fragment, null,
            React.createElement(TextBox, { value: name, setValue: setName }),
            React.createElement(Checkbox, { className: styles.center, checked: sendNotifications, setChecked: setSendNotifications }),
            React.createElement("div", { className: cn(styles.itemButtons, styles.last) },
                React.createElement(Button, { label: strings.cancelBtnLabel, onClick: toggleEdit }),
                React.createElement(Button, { label: strings.saveBtnLabel, kind: "primary", onClick: save })))));
}
export function MySavedSearches({ strings }) {
    const [items, setItems] = useArrayState([]);
    async function fetchItems() {
        setItems(await userApiClient.getSavedSearches());
    }
    async function saveItem(item) {
        var index = items.findIndex(i => i.searchQueryId == item.searchQueryId);
        if (index == -1)
            return;
        var newItem = await userApiClient.updateSearch(item);
        setItems.editAt(index, () => newItem);
    }
    async function deleteItem(item) {
        var index = items.findIndex(i => i.searchQueryId == item.searchQueryId);
        if (index == -1)
            return;
        await userApiClient.deleteSearch(item.searchQueryId);
        setItems.removeAt(index);
    }
    useEffect(() => {
        fetchItems();
    }, []);
    return (React.createElement("div", { className: styles.items },
        React.createElement(Item, { strings: strings }),
        items.map(itm => React.createElement(Item, { key: itm.searchQueryId, strings: strings, item: itm, onSave: saveItem, onDelete: deleteItem }))));
}
